//imports
import { all } from 'redux-saga/effects';

//Views

import createEditTagSagas from 'Modules/tags/.components/createEditTag/redux/saga';
import deleteTagSagas from 'Modules/tags/.components/deleteTag/redux/saga';
import bulkTagsSagas from 'Modules/tags/.components/bulkTags/redux/saga';


export default function* rootSaga() {
    yield all([
        createEditTagSagas(),
        deleteTagSagas(),
        bulkTagsSagas()
    ]);
}